import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { TabBar, Dropdown, XIColors } from '@inmoment/the-kitchen';
import { _dataDropdown } from '@inmoment/the-kitchen-data';
import { KitchenThemeContext } from '../../App';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Example', 'ErrorObject', 'ErrorStates'].map(convertArrayToTabBar);
export const data2 = ['Example', 'ToolTipProps', 'ClockDirection'].map(convertArrayToTabBar);
export const data3 = ['InternalDropdownProps'].map(convertArrayToTabBar);
export const data4 = ['Example', 'DropdownObject', 'ClockDirection'].map(convertArrayToTabBar);
export const data5 = ['Visual Example', 'React Code'].map(convertArrayToTabBar);
export const data6 = ['Visual Example', 'React Code'].map(convertArrayToTabBar);
export const data7 = ['Example', 'DropdownButtons', 'ButtonObject'].map(convertArrayToTabBar);
export const data8 = ['Example', 'Dropdown Group'].map(convertArrayToTabBar);

export const DropdownDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('Example');
  const [tab2, setTab2] = React.useState('Example');
  const [tab3, setTab3] = React.useState('InternalDropdownProps');
  const [tab4, setTab4] = React.useState('Example');
  const [tab5, setTab5] = React.useState('Visual Example');
  const [tab6, setTab6] = React.useState('Visual Example');
  const [tab7, setTab7] = React.useState('Example');
  const [tab8, setTab8] = React.useState('Example');
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <div>
      <p className="kxi-text-300 kxi-text-normal">Dropdown Types</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data5} color={theme} onTabChange={({ tab }) => setTab5(tab!.title)} />
      </div>
      {tab5 === 'Visual Example' && (
        <CodeBlock hasTopRadius={false}>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Dropdown data={[]} type={'pill'} placeholder={'pill'} label={'pill'} />
            <Dropdown data={[]} type={'fab'} label={'fab'} internalProps={{ fab: { icon: 'fab_plus', color: theme } }} />
            <Dropdown data={[]} type={'icon'} label={'icon'} internalProps={{ iconButton: { icon: 'ab_testing', color: theme } }} />
            <div style={{ background: XIColors.orca.primary, padding: '0px 12px 12px 12px', borderRadius: 12 }}>
              <p className="kxi-text-small kxi-high-contrast">orca color for demonstration only</p>
            </div>
          </div>
        </CodeBlock>
      )}
      {tab5 === 'React Code' && (
        <CodeBlock
          hasTopRadius={false}
          code={`<Dropdown data={[]} type={'pill'} placeholder={'pill'} label={'pill'} />
<Dropdown data={[]} type={'fab'} label={'fab'} internalProps={{ fab: { icon: 'fab_plus' } }} />
<Dropdown data={[]} type={'icon'} label={'icon'} internalProps={{ iconButton: { icon: 'ab_testing' } }} />
<Dropdown data={[]} type={'text-dark'} label={'text-dark'} placeholder={'text-dark'} />
<Dropdown data={[]} type={'text-light'} label={'text-light'} placeholder={'text-light'} />
        `}
        />
      )}
      <br />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">Dropdown Select Types</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data6} color={theme} onTabChange={({ tab }) => setTab6(tab!.title)} />
      </div>
      {tab6 === 'Visual Example' && (
        <CodeBlock hasTopRadius={false}>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Dropdown data={_dataDropdown.data} placeholder={'single'} select="single" label="single select" />
            <Dropdown data={_dataDropdown.data} placeholder={'multi'} select="multi" label="multi select" />
          </div>
        </CodeBlock>
      )}
      {tab6 === 'React Code' && (
        <CodeBlock
          hasTopRadius={false}
          code={`<Dropdown data={_dataDropdown.data} select="single" />
<Dropdown data={_dataDropdown.data} select="multi" />`}
        />
      )}
      <br />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">Dropdown Data</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data4} color={theme} onTabChange={({ tab }) => setTab4(tab!.title)} />
      </div>
      {tab4 === 'Example' && (
        <CodeBlock
          hasTopRadius={false}
          code={`[
  {
    title: 'Pepper X',
    isSelected: true,
    subtitle: '3,180,000',
    color: 'error',
    visual: 'https://www.customurl.com/image.png'
  },
  {,
    title: 'Dragon's Breath',
    subtitle: '2,480,000',
    visual: 'ab_testing'
  },
  {
    title: 'Carolina Reaper',
    subtitle: '2,200,000',
    visual: 'CX'
  }
]`}
        />
      )}
      {tab4 === 'DropdownObject' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface DropdownObject {
  title: string;
  subtitle?: string;
  id?: string;
  visual?: Icons | Clouds | string;
  isSelected?: boolean;
  disabled?: boolean;
  color?: ErrorStates | Clouds | 'orca';
  submenu?: DropdownObject[];
}`}
        />
      )}
      {tab4 === 'ClockDirection' && (
        <CodeBlock
          hasTopRadius={false}
          code={`// Positioned like a clock
//   11 12 1
// 10    /   2
//  9   . _  3
//  8        4
//   7  6  5

export type ClockDirection = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;`}
        />
      )}
      <br />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">Dropdown Groups</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data8} color={theme} onTabChange={({ tab }) => setTab8(tab!.title)} />
      </div>
      {tab8 === 'Example' && (
        <CodeBlock
          hasTopRadius={false}
          code={`<Dropdown
  data={[
    { title: 'Orange', id: '01' },
    { title: 'Apple', id: '02' },
    { title: 'Banana', id: '03' },
    { title: 'Broccoli', id: '11' },
    { title: 'Asparagus', id: '12' },
  ]}
  groups={[
    { title: 'Fruits', ids: ['01', '02', '03'] },
    { title: 'Vegetables', ids: ['11', '12'] },
  }]>
</Dropdown>`}
        />
      )}
      {tab8 === 'Dropdown Group' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface DropdownGroup {
  title?: string;
  ids?: string[];
}`}
        />
      )}
      <br />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">Dropdown Buttons</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data7} color={theme} onTabChange={({ tab }) => setTab7(tab!.title)} />
      </div>
      {tab7 === 'Example' && (
        <CodeBlock
          hasTopRadius={false}
          code={`{
  primary: {
    text: 'Primary Action'
    onClick: () => {},
  },
  secondary: {
    text: 'Secondary Action'
    onClick: () => {},
  },
}`}
        />
      )}
      {tab7 === 'DropdownButtons' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface DropdownButtons {
  primary?: ButtonObject;
  secondary?: ButtonObject;
}`}
        />
      )}
      {tab7 === 'ButtonObject' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface ButtonObject {
  text: string;
  onClick?(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
}`}
        />
      )}
      <br />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">Dropdown Status</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data1} color={theme} onTabChange={({ tab }) => setTab(tab!.title)} />
      </div>
      {tab === 'Example' && (
        <CodeBlock
          hasTopRadius={false}
          code={`{
  state: 'error';
  text: 'Oh no!';
}`}
        />
      )}
      {tab === 'ErrorObject' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface ErrorObject {
  state: ErrorStates;
  text?: string;
}`}
        />
      )}
      {tab === 'ErrorStates' && <CodeBlock hasTopRadius={false} code="export type ErrorStates = 'success' | 'warning' | 'error';" />}
      <br />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">Dropdown Tooltip</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data2} color={theme} onTabChange={({ tab }) => setTab2(tab!.title)} />
      </div>
      {tab2 === 'Example' && (
        <CodeBlock
          hasTopRadius={false}
          code={`{
  direction: 6;
  text: "Whoo tooltip!";
}`}
        />
      )}
      {tab2 === 'ToolTipProps' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface ToolTipProps {
  direction?: ClockDirection;
  isOpenOnClick?: boolean;
  text: string;
  maxWidth?: number;
}`}
        />
      )}

      {tab2 === 'ClockDirection' && (
        <CodeBlock
          hasTopRadius={false}
          code={`// Positioned like a clock
//   11 12 1
// 10    /   2
//  9   . _  3
//  8        4
//   7  6  5

export type ClockDirection = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;`}
        />
      )}
      <div style={{ display: 'flex' }}>
        <div style={{ display: 'flex', padding: 24, justifyContent: 'center', alignItems: 'center' }}>
          <img src={'/fab_tooltip.gif'} width={444} height={186} alt="fab-tooltip" />
        </div>
      </div>
      <br />
      <p className="kxi-text-300 kxi-text-normal">Dropdown Internal Props</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data3} color={theme} onTabChange={({ tab }) => setTab3(tab!.title)} />
      </div>
      {tab3 === 'InternalDropdownProps' && (
        <CodeBlock
          hasTopRadius={false}
          code={`// Use standard HTML/React props for DivProps. Applied to wrapper of dropdown. Ex: {style: {width: 200}}
// See component <IconButton /> for respective props
// See component <FAB /> for respective props

export interface InternalDropdownProps {
  wrapper?: DivProps;
  iconButton?: IconButtonProps;
  fab?: FABProps;
}`}
        />
      )}
      <br />
      <br />
      <br />
      <p className="kxi-text-300 kxi-text-normal">Why is disabling a user's scroll important when using a dropdown?</p>
      <br />
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1, paddingRight: 24 }}>
          <p className="kxi-text-normal">
            You should <b>always disable a user's ability to scroll</b> when a {`<Dropdown />`} is located within some kind of scrollable container(s)
            ({`<body>`} is exempt as it is always disabled for you) that can move the dropdown. Why? Because the dropdown menu will statically stay
            positioned where it originally opened (see example on right). This is intentional, or at the very least implemented as best of possible.
            This is how placing the menu works with React Portals, and there is no clean or optimized way (discovered yet) to keep the menu placed
            under the dropdown without it freaking out and looking terrible. We made this decision because not only does it look the best visually.
            Other major component libraries also have not solved the issue and just disable the scroll.
          </p>
        </div>
        <div>
          <img src={'/bad_dropdown_scroll.gif'} width={328} height={300} style={{ borderRadius: 6 }} alt="dropdown_scroll" />
        </div>
      </div>
      <br />
      <p className="kxi-text-normal">
        Pass full HTML elements into the 'elementsToDisableScroll' prop that have the ability to scroll, and the {`<Dropdown>`} component will take
        care of everything for you. Don't forget about responsive sizes and elements in mobile too!
      </p>
    </div>
  );
};
